import { GetterTree } from 'vuex'
import { RootState } from '@/store/types'
import { PronosticoAireState } from '@/store/modules/pronostico-aire/types'

export const getters: GetterTree<PronosticoAireState, RootState> = {
  getPronosticoAire (state: PronosticoAireState) {
    return state
  },
  hasLink (state: PronosticoAireState) {
    return state.link_descarga || false
  },
  deletePronosticoAire (state: PronosticoAireState) {
    return state
  }
}
